import { useEffect } from "react";
import NextLink from "next/link";
import Head from "next/head";
import { useRouter } from "next/compat/router";
import { Heading, Box, Link, IconFa } from "@cruk/cruk-react-components";
import { faCaretLeft } from "@fortawesome/free-solid-svg-icons";

import { useSwrGet } from "@fwa/src/hooks/useSwrGet";
import { queryAsString } from "@fwa/src/utils/urlUtils";
import { fwsUrSuperTeamPageSlug } from "@fwa/src/services/superTeamService";
import { useBrandContext } from "@fwa/src/contexts/BrandContext";
import { getBrandForPage } from "@fwa/src/utils/pageUtils";

import { ErrorPageWrapper } from "@fwa/src/components/ErrorPageWrapper";
import { SuperTeamFundraisingPages } from "@fwa/src/components/SuperTeamFundraisingPages";

import sharedStyles from "@fwa/src/components/styles.module.css";

import { type BrandNameType, type SuperTeamPageType } from "@fwa/src/types";

export const SuperTeamFundraisingPagesPage = () => {
  const router = useRouter();
  const { slug } = router?.query || {};
  const slugString = queryAsString(slug);
  const url = slugString?.length
    ? `${fwsUrSuperTeamPageSlug({
        slug: slugString,
      })}`
    : null;
  const { data: page, error } = useSwrGet<SuperTeamPageType>(url);
  const themeName = page ? page?.theme || getBrandForPage(page) : null;
  const [brandName, setBrandName] = useBrandContext();

  useEffect(() => {
    if (!!themeName && themeName !== brandName) {
      setBrandName(themeName as BrandNameType);
    }
  }, [themeName, brandName, setBrandName]);

  return (
    <ErrorPageWrapper error={error!}>
      {page ? (
        <>
          <Head>
            <title>{page.title} pages</title>
          </Head>
          <div className={sharedStyles["content-max-width"]}>
            <Box backgroundColor="background-light" padding="s" marginTop="m">
              <NextLink
                href={`/unite${page.url.slice(page.url.lastIndexOf("/"))}`}
                data-cta-type="link-super-team"
              >
                <Link appearance="secondary" as="span">
                  <IconFa faIcon={faCaretLeft} size="s" />
                  Back to {page.title}
                </Link>
              </NextLink>
            </Box>

            {/* members block */}
            <Box
              backgroundColor="background-light"
              padding="s"
              marginBottom="xxl"
            >
              <Heading h1 textSize="xxl" overflowWrap="break-word">
                {page.title} Giving Pages
              </Heading>
              <SuperTeamFundraisingPages
                teamId={page.uniqueId}
                itemsPerPage={12}
              />
            </Box>
          </div>
        </>
      ) : null}
    </ErrorPageWrapper>
  );
};

export default SuperTeamFundraisingPagesPage;
